import { put, retry, select, takeEvery } from 'redux-saga/effects';
import getAutoCompleteOptionsQuery from '../../../../Components/AutoCompleteInput/getAutoCompleteOptions';
import ActionTypes from '../../../../Data/ActionTypes';

function* worker(action) {
  const state = yield select();
  const { payload } = action;
  const { componentId, value } = payload;
  const { formId } = state.formConfig;

  try {
    const requestArguments = {
      answerQuery: value,
      componentId,
      webformId: formId,
    };

    const args = {
      variables: requestArguments,
    };

    const options = yield retry(3, 1000, getAutoCompleteOptionsQuery, args);

    yield put({
      type: 'COMPONENTS/setOptions',
      payload: {
        componentId,
        options,
      },
    });
  } catch (error) {
    // Todo possibly push to datadog so we can track these failures
    yield put({ type: 'GET_AUTOCOMPLETE_OPTIONS_FAILED', payload: { error } });
  }
}

export const getAutoCompleteOptionsAction = ({ componentId, value }) => ({
  type: ActionTypes.GET_AUTOCOMPLETE_OPTIONS,
  payload: {
    componentId,
    value,
  },
});

export default function* getAutoCompleteOptions() {
  yield takeEvery(ActionTypes.GET_AUTOCOMPLETE_OPTIONS, worker);
}
